import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-blue-900 py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-125" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-126" data-mp="1dxt7p0idz4i7">
        <div className="text-center" data-id="element-127" data-mp="2bk8pk3eq646a">
          <span className="silver-metal inline-flex items-center gap-2 rounded-md px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-blue-950" data-id="element-128" data-mp="2bj7dpwpvxdni">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="21m2otp4nn430" /> Material completo para el aula
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-130" data-mp="1wn85mm2rzdid">
            Los {totalVolumes} tomos del Megapack
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-131" data-mp="q4jhplnyegz6">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-slate-300/25 bg-blue-950 shadow-lg shadow-black/20" data-id="element-132" data-mp="1ivs00pax196d" data-mpi={index}>
                <div className="flex items-center gap-4 border-b border-slate-300/20 bg-blue-950 px-6 py-5" data-id="element-133" data-mp="14vpix5afmjs6">
                  <span className="silver-metal flex h-12 w-12 shrink-0 items-center justify-center rounded-md text-blue-950" data-id="element-134" data-mp="q7mc5tokf42b">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-135" data-mp="v5xlm3ay7ck0" />
                  </span>
                  <div data-id="element-136" data-mp="h6er4db27zq6">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-slate-300" data-id="element-137" data-mp="h892p10fyfhl">
                      Tomo {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-white" data-id="element-138" data-mp="2nvq5dvloxfww">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-139" data-mp="2e42jea7wkr2t">
                  <p className="font-semibold text-slate-200" data-id="element-140" data-mp="2e29dix546avv">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-slate-400" data-id="element-141" data-mp="296u3yhe53159">
                    ¿Qué resuelve en el aula?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-slate-300" data-id="element-142" data-mp="31uy8v0ovza6w">{module.classroom}</p>

                  <ul className="mt-5 grid flex-1 content-start gap-2" data-id="element-143" data-mp="2wtsfr1rbdkwu">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-slate-100" data-id="element-144" data-mp="2ssoxy9pphesz">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" aria-hidden="true" data-id="element-145" data-mp="1lh80viunc1rz" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-slate-300 bg-blue-900 p-4 text-sm leading-relaxed text-slate-100" data-id="element-146" data-mp="3t39hy75py8en">
                    <b className="font-extrabold text-white" data-id="element-147" data-mp="5wz4al5sct6i">Resultado: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl border border-slate-300/30 bg-blue-950 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-148" data-mp="fnbkk16ki06u">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-slate-300" data-id="element-149" data-mp="ongjro1lxs9x">Colección principal</p>
          <p className="text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-150" data-mp="tmjo169rjugu">
            {totalVolumes} tomos premium <span className="mx-2 text-slate-400" data-id="element-151" data-mp="2qfmsp6b5gbkf">·</span> Contenido actualizado 2026
          </p>
        </div>
      </div>
    </section>;
}